import React, { useState } from 'react';

const initialTags = [
    'JavaScript', 'React', 'Python', 'SQL', 'UX/UI',
    'Agile', 'AWS', 'Docker', 'Figma', 'Excel',
];

const SidebarDDTags = ({ title = 'Tags' }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [tags, setTags] = useState(initialTags);
    const [selectedTags, setSelectedTags] = useState([]);
    const [newTag, setNewTag] = useState('');

    const toggleDropdown = () => setIsOpen(!isOpen);

    const toggleTag = (tag) => {
        setSelectedTags((prev) =>
            prev.includes(tag) ? prev.filter((t) => t !== tag) : [...prev, tag]
        );
    };

    const handleAddTag = () => {
        const trimmed = newTag.trim();
        if (trimmed && !tags.includes(trimmed)) {
            setTags([...tags, trimmed]);
            setNewTag('');
        }
    };

    return (
        <div className="w-full text-[#5A6474]">
            {/* Toggle Button */}
            <button
                onClick={toggleDropdown}
                className="w-full flex justify-between items-center px-4 py-2 bg-white hover:bg-gray-100 font-dmsans text-sm font-bold rounded-md shadow-sm transition"
            >
                <span className="truncate">{title}</span>
                <svg
                    className={`w-4 h-4 transform transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    viewBox="0 0 24 24"
                >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                </svg>
            </button>

            {/* Dropdown Content */}
            {isOpen && (
                <div className="w-full px-4 py-3 bg-white rounded-b-md border-t-0 border shadow-sm">
                    {/* Tags List */}
                    <div className="flex flex-wrap gap-2 mb-3 max-h-40 overflow-y-auto">
                        {tags.map((tag) => (
                            <button
                                key={tag}
                                onClick={() => toggleTag(tag)}
                                className={`px-3 py-1 text-sm rounded-full border transition font-dmsans ${selectedTags.includes(tag)
                                    ? 'bg-blue-100 hover:bg-blue-200 text-blue-700'
                                    : 'bg-[#f0f0f0] hover:bg-gray-200 text-[#5A6474]'
                                    }`}
                            >
                                {tag}
                            </button>
                        ))}
                    </div>

                    {/* Add New Tag Input */}
                    <div className="flex flex-wrap sm:flex-row gap-2">
                        <input
                            type="text"
                            placeholder="+ Add tag"
                            value={newTag}
                            onChange={(e) => setNewTag(e.target.value)}
                            className="flex-1 px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring focus:ring-blue-300"
                        />
                        <button
                            onClick={handleAddTag}
                            className="px-4 py-2 bg-blue-500 text-white text-sm rounded-md hover:bg-blue-600"
                        >
                            Add
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default SidebarDDTags;
